import React from "react";
import {
  Button,
  Stack,
  TextField,
  MenuItem,
  Switch,
  FormControlLabel,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";

// ✅ Validation schema
const validationSchema = yup.object().shape({
  item_name: yup.string().required("Required"),
  price: yup.number().positive("Must be positive").required("Required"),
  category: yup.string().required("Required"),
});

const MenuItemForm = ({ initialValues, onSubmit, editMode }) => {
  // ✅ Default form values
  const defaults = {
    item_name: "",
    price: "",
    tax_rate: 5,
    category: "",
    status: true,
  };

  const values = initialValues || defaults;


const categories = [
  "Starters",
  "Main Course",
  "Breads",
  "Rice & Biryani",
  "Snacks",
  "Beverages",
  "Desserts",
  "Salads & Sides",
  "Other"
];

  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={values}
      validationSchema={validationSchema}
      enableReinitialize
    >
      {({ values, errors, touched, handleBlur, handleChange, handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <Stack spacing={3}>
            {/* 📝 Item Name */}
            <TextField
              fullWidth
              variant="filled"
              label="Item Name"
              name="item_name"
              value={values.item_name}
              onChange={handleChange}
              onBlur={handleBlur}
              error={!!touched.item_name && !!errors.item_name}
              helperText={touched.item_name && errors.item_name}
            />

            {/* 💰 Price */}
            <TextField
              fullWidth
              variant="filled"
              type="number"
              label="Price"
              name="price"
              value={values.price}
              onChange={handleChange}
              onBlur={handleBlur}
              error={!!touched.price && !!errors.price}
              helperText={touched.price && errors.price}
            />

            {/* 🧾 Tax (fixed for now) */}
            <TextField
              fullWidth
              variant="filled"
              type="number"
              label="Tax Rate (%)"
              name="tax"
              value={values.tax_rate}
              disabled
            />

            {/* 🍴 Category Dropdown */}
            <TextField
              select
              fullWidth
              variant="filled"
              label="Category"
              name="category"
              value={values.category}
              onChange={handleChange}
              onBlur={handleBlur}
              error={!!touched.category && !!errors.category}
              helperText={touched.category && errors.category}
            >
              {categories.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>

            {/* ⚙️ Active / Inactive Switch */}
            <FormControlLabel
              control={
                <Switch
                  checked={values.status}
                  name="status"
                  onChange={(e) =>
                    handleChange({
                      target: { name: "status", value: e.target.checked },
                    })
                  }
                  color="secondary"
                />
              }
              label={values.status ? "Active" : "Inactive"}
            />

            {/* ✅ Submit / Update Button */}
            <Button
              fullWidth
              size="large"
              type="submit"
              color="secondary"
              variant="contained"
              sx={{ fontSize: "15px" }}
            >
              <b>{editMode ? "Update" : "Submit"}</b>
            </Button>
          </Stack>
        </form>
      )}
    </Formik>
  );
};

export default MenuItemForm;